window._ = require('lodash');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.$ = window.jQuery = require('jquery');

window.$.ajaxSetup({ headers: { 'X-CSRF-TOKEN': window.$('meta[name="csrf-token"]').attr('content') } });

import 'bootstrap';

import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
window.Fancybox = Fancybox
/*Fancybox.bind("[data-fancybox]", {
    // Your options go here
});*/

import swal from 'sweetalert2/dist/sweetalert2';
window.swal = swal;

import { tns } from 'tiny-slider/src/tiny-slider';
window.tns = tns;

// require('@kumsalagency/olymposfont/src/index');




//Select2
require("select2/dist/js/i18n/tr");
require("select2/dist/js/i18n/en");
require("select2/dist/js/i18n/ar");
require("select2/dist/js/i18n/ru");
require("select2/dist/js/i18n/fr");
require("select2/dist/js/i18n/it");
require("select2/dist/js/i18n/de");
import select2 from 'select2/dist/js/select2';


require('./template/template');

